import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Department } from '../models/department.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  constructor(private http: HttpClient) {}

  getAllDepartments(): Observable<Department[]> {
    return this.http.get<Department[]>(environment.api_service_department);
  }

  getDepartmentById(id: string): Observable<Department> {
    return this.http.get<Department>(`${environment.api_service_department}/${id}`);
  }

  createDepartment(department: Department): Observable<Department> {
    return this.http.post<Department>(environment.api_service_department, department);
  }

  updateDepartment(id: string, department: Department): Observable<Department> {
    return this.http.put<Department>(`${environment.api_service_department}/${id}`, department);
  }

  deleteDepartment(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.api_service_department}/${id}`);
  }
}
